import axiosInstance from "../../../helpers/api";

export const getAllStudents = (formData) => {
  const { payload: page, searchTerm, subjectId } = formData;
  let url = `/admin/students?page=${page}&name=${searchTerm || ''}`;
  
  // If subjectId is provided, add it to the query parameters
  if (subjectId) {
    url += `&subject_id=${subjectId}`;
  }
  
  return axiosInstance.get(url);
};

export const clearSession = (id) => {
  return axiosInstance.get(`/admin/students/clear_session/${id}`);
};

export const editStudents = (formData) => {
  return axiosInstance.post(
    `/admin/students/${formData.id}`,
    formData.formData
  );
};

export const createStudents = (formData) => {
  return axiosInstance.post("/admin/students", formData);
};

export const getStudent = (id) => {
  return axiosInstance.get(`/admin/students/${id}`);
};

export const deleteStudent = (id, reason) => {
  const url = reason 
    ? `/admin/students/${id}?reason=${encodeURIComponent(reason)}`
    : `/admin/students/${id}`;
  return axiosInstance.delete(url);
};

export const getStudentReport = (id) => {
  return axiosInstance.get(`/admin/Students_info/${id}`);
};
export const restricStudent = (data) => {
  return axiosInstance.post(
    `/admin/students/restrict/${data?.id}`,
    data.formData
  );
};

export const addBulkStudent = (formData) => {
  return axiosInstance.post(`/admin/students/add_bulk`, formData);
};

export const getStudentsRequests = (formData) => {
  return axiosInstance.get(
    `/admin/students/pending?page=${formData?.payload}&name=${formData?.searchTerm}`
  );
};

export const getStudentsForCsv = (formData) => {
  return axiosInstance.get(`/admin/students/list_all`);
};

export const getStudentsForBulkMessage = (subject_id) => {
  return axiosInstance.get(`/admin/students/list_all?subject_id=${subject_id}`);
};

export const getAprovedStudents = (formData) => {
  let url = `/admin/students/approved?page=${formData?.payload}&name=${formData?.searchTerm || ''}`;
  
  // If studentGroupId is provided, add it to the query parameters
  if (formData?.studentGroupId) {
    url += `&student_group_id=${formData.studentGroupId}`;
  }
  
  return axiosInstance.get(url);
};

export const approveStudent = (id) => {
  return axiosInstance.post(`/admin/students/approve/${id}`);
};

export const rejectStudent = (id) => {
  return axiosInstance.post(`/admin/students/reject/${id}`);
};

export const resendPassword = (id) => {
  return axiosInstance.get(`/admin/students/resend_password/${id}`);
};

export const sendCredentials = (id) => {
  return axiosInstance.get(`/admin/students/send_credentials/${id}`);
};

export const getInactiveStudents = (formData) => {
  const { payload: page, searchTerm, flag } = formData;
  let url = `/admin/students/get_inactive_students?page=${page}&name=${searchTerm || ''}`;
  if (flag !== undefined) {
    url += `&flag=${flag}`;
  }
  return axiosInstance.get(url);
};
